import { render } from "./NeeraDetailRow.vue?vue&type=template&id=67b5ee44"
import script from "./NeeraDetailRow.vue?vue&type=script&lang=js"
export * from "./NeeraDetailRow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__